<script lang="ts">
	//UI
	import Title from "@hitit/hub/src/v7/components/notice/Title.svelte";
	import NoticeReader from "../components/notice/NoticeReader.svelte";
	import ContainerLoading from "../components/common/ContainerLoading.svelte";
	import { GoBackButton } from "@hitit/new_ui/src";

	//Utils
	import { api } from "../../stores";
	import { processingDate } from "../utils";
	import { newAlert } from "../store";
	//Types
	//Props
	export let noticeId: string;

	//Constants
	//Variables
	let loading = false;
	let date = "";
	let article = "";
	let title = "";
	//Functions
	const backClickHandler = () => history.back();
	async function getNotice(noticeId: string) {
		try {
			loading = true;
			const { data } = await $api.getNewsDocument(noticeId);
			article = data.newsDTO.content;
			date = processingDate(data.newsDTO.publishedDate);
			title = data.newsDTO.title;
			updateNewAlert();
		} catch (error) {
			//
		} finally {
			loading = false;
		}
	}

	async function updateNewAlert() {
		try {
			const { data } = await $api.getUnReadNewList();
			$newAlert.notice = data.totalElements !== 0;
		} catch (error) {}
	}

	//Do
	$: getNotice(noticeId);
</script>

{#if loading}
	<ContainerLoading />
{/if}

<div class="container">
	<div class="title">
		<Title />
	</div>
	<div class="back">
		<GoBackButton on:click={backClickHandler} />
	</div>
	<div class="body">
		<NoticeReader title={title} date={date} article={article} />
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		padding-top: 50px;
		position: relative;
		.title {
			display: none;
		}

		.back {
			width: 30px;
			height: 27px;
			position: absolute;
			top: 0px;
			right: 0px;
		}

		.body {
			:global(#Notice-reader) {
				min-height: calc(100vh - 150px);
			}
		}
	}

	@include DesktopSize {
		.container {
			padding-top: 30px;
			gap: 30px;
			.title {
				display: block;
			}
			.back {
				top: 63px;
			}
			.body {
				:global(#Notice-reader) {
					min-height: calc(100vh - 240px);
				}
			}
		}
	}
</style>
